<template>
    <NoData />
</template>

<script>
    export default {
        name: 'footballPlayerStats'
    }
</script>